import * as Swiper from 'swiper/dist/js/swiper.js'; 
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class mobilizersSlider {
    constructor() {
        this.containers = document.querySelectorAll('.cp-slider-mobilizers');
        if (this.containers.length === 0) return;

        this.pinIcons = document.querySelectorAll('.icon-card-pin');

        this.containers.forEach((container, index) => {
            this.slider = container.querySelector('.js-slider-mobilizers');
            this.slider.classList.add(`s-${index}`);
            this.numberSlides = container.querySelectorAll('.item').length;

            if(container.getElementsByClassName('swiper-pagination')[0]){
                container.getElementsByClassName('swiper-pagination')[0].classList.add(`swiper-pagination-${index}`);
            }

            if(container.getElementsByClassName('swiper-scrollbar')[0]){
                container.getElementsByClassName('swiper-scrollbar')[0].classList.add(`swiper-scrollbar-${index}`);
            }

            if(container.querySelector('.js-text-button-prev')){
                container.querySelector('.js-text-button-prev').classList.add(`button-prev-${index}`)
            }
            if(container.querySelector('.js-text-button-next')){
                container.querySelector('.js-text-button-next').classList.add(`button-next-${index}`)
            }

            this.initSlider(this.slider, index);
        })

    }

    initSlider(slider, index) {
        gsap.registerPlugin(ScrollTrigger);
        if (slider.querySelectorAll('.swiper-slide').length <= 1) {
          slider.querySelector('.nav-container').classList.add('hidden');
          return;
        }

        if(window.innerWidth < 768){
            this.slides_per_view = 1.1;
            this.space = 16;
        }else{
            this.slides_per_view = 1.3;
            this.space = 24;
        }
        const swiper = new Swiper(slider, {
            slidesPerView: this.slides_per_view,
            slideClass: 'item',
            spaceBetween: this.space,
            navigation: {
                nextEl: `.button-next-${index}`,
                prevEl: `.button-prev-${index}`,
            },
            pagination: {
                el: `.swiper-pagination-${index}`,
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: '-current',
                clickable: true,
            },
        });

        swiper.on('sliderMove', () => {
            slider.querySelectorAll('.icon-card-pin svg').forEach((icon) => icon.classList.remove('animated'));
        })
        swiper.on('transitionStart', () => {
            slider.querySelectorAll('.icon-card-pin svg').forEach((icon) => icon.classList.remove('animated'));
        })
        swiper.on('transitionEnd', () => {
            slider.querySelectorAll('.icon-card-pin svg').forEach((icon) => icon.classList.remove('animated'));
            slider.querySelector('.swiper-slide-active .icon-card-pin svg').classList.add('animated');
        })


        window.addEventListener('load', () => {
            gsap.utils.toArray(".icon-card-pin").forEach((pin) => {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: pin,
                        start: "center center",
                        toggleClass: "animated"
                    }
                })
            })
        });
    }
}
